// supabaseClient.js
import { createClient } from '@supabase/supabase-js'


//Macrotech
//const SUPABASE_URL = 'https://zcriodlsfpwejuzkwcwz.supabase.co'
//const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpjcmlvZGxzZnB3ZWp1emt3Y3d6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyOTI1MzYsImV4cCI6MjA2NDg2ODUzNn0.0Z22H5IjP1kmY9kBwiMxNlVOgJ_WP48xPzOVKXHjpJo'


//garvit account private
const SUPABASE_URL = 'https://qottihpcuyoudgwhdelr.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFvdHRpaHBjdXlvdWRnd2hkZWxyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxMTY2NDAsImV4cCI6MjA2NTY5MjY0MH0.YkFsljKiLX6rRlwNDW0gjIXuRy1AXA5DGo8zKRU8KJw'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
